import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SubmitButton } from 'shared-components';

// `loading` disables the button and swaps its label while a request is in flight,
// so a second click cannot send the form twice.
const PortalSubmitButton = ({ loading, disabled, ...props }) => {
  const intl = useIntl();
  const id = loading ? 'submit-button-loading' : 'submit-button';

  return (
    <SubmitButton
      {...props}
      buttonType="primary"
      size="large"
      disabled={loading || disabled}
      aria-busy={loading}
      value={intl.formatMessage({
        id,
        description: loading ? 'Submit button while loading' : 'Submit button',
        defaultMessage: intl.messages[id],
      })}
    />
  );
};

PortalSubmitButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

PortalSubmitButton.defaultProps = {
  loading: false,
  disabled: false,
};

export default PortalSubmitButton;
